import React from 'react'
import { discountFlowConfig } from 'src/assets/DiscountsConfig'
import { DiscountFormProvider } from 'src/components/discounts/v2/hooks/useDiscountForm'
import GenericSlideInDialog from 'src/components/common/containers/GenericSlideInDialog'
import DiscountCreationFlow from 'src/components/discounts/discount-creation-flow/DiscountCreationFlow'
import { useLocale } from 'src/lib/hooks/useLocal'
import DiscountCreationContent from './DiscountCreationContent'
import { CopiedDiscountInfo, DiscountInfo } from 'src/lib/types/common/discounts'
import {
  ExperimentCreatedDiscountType,
  ExperimentCreationOptions,
  ExperimentCreationType
} from 'src/lib/types/experiments'
import { UiConfigDiscountType } from 'src/lib/types/discountsV2'

interface DiscountCreationDialogProps {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  setCreatedDiscount: (discountData: ExperimentCreatedDiscountType) => void
  copiedDiscountInfo?: CopiedDiscountInfo
  type: ExperimentCreationType
  context?: 'experiment' | 'none'
  initialDiscountType?: UiConfigDiscountType
  onSaveSuccess?: (createdDiscount: any) => void
}

const DiscountCreationDialog: React.FC<DiscountCreationDialogProps> = ({
  isOpen,
  setIsOpen,
  setCreatedDiscount,
  copiedDiscountInfo,
  type,
  context = 'none',
  initialDiscountType,
  onSaveSuccess
}) => {
  const { t } = useLocale()
  const flowTypeMap: Partial<Record<ExperimentCreationOptions, string>> = {
    [ExperimentCreationOptions.COUPONS]: 'create-discount',
    [ExperimentCreationOptions.PAYMENT_OFFERS]: 'create-payment-offer',
    [ExperimentCreationOptions.EXIT_COUPONS]: 'create-exit-coupon',
  }
  const flowConfig = discountFlowConfig.find(flow => flow.type === (flowTypeMap[type as ExperimentCreationOptions] ?? 'create-discount'))

  if (!flowConfig) return <></>

  return (
    <>
      <DiscountFormProvider initialDiscountType={initialDiscountType} onSaveSuccess={onSaveSuccess}>
        <GenericSlideInDialog isOpen={isOpen} setIsOpen={setIsOpen}>
          <DiscountCreationContent
            setIsOpen={setIsOpen}
            copiedDiscountInfo={copiedDiscountInfo}
            setCreatedDiscount={setCreatedDiscount}
            flowConfig={flowConfig}
            context={context}
          />
        </GenericSlideInDialog>
      </DiscountFormProvider>
    </>
  )
}

export default DiscountCreationDialog
